import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const SearchIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue8b6'}</MuiIcon>
    );
}
